import PopupComponent from '@components/std-components/Popup'
import { useObserver } from 'mobx-react-lite'
import React from 'react'
import { FC } from 'react'
import { TableSettingsIcon } from '@components/UI-Components/svg'
import Icon from '@components/std-components/Icons'
import { useTranslation } from 'react-i18next'
import Tooltip from '@material-ui/core/Tooltip'
import { EnhancedTableSettingsContainer } from './LazyEnhancedTableSettings'

export const EnhancedTableSettingsPopup: FC<{
  popupProps: any
  settingProps: any
}> = ({ popupProps, settingProps }) => {
  return useObserver(function useHook() {
    const { onClose } = popupProps
    const { t } = useTranslation()
    return (
      <PopupComponent
        trigger={
          <div>
            <Tooltip title={t('order.tableSettings', 'Table settings')}>
              <div>
                <Icon imageSrc={TableSettingsIcon} alt={'TableSettings'} />
              </div>
            </Tooltip>
          </div>
        }
        contentStyle={{
          width: 790,
          height: '70%',
          padding: 0,
          boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.15)'
        }}
        modal
        {...popupProps}
      >
        <EnhancedTableSettingsContainer {...settingProps} onClose={onClose} />
      </PopupComponent>
    )
  })
}
